import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { GridBooleanColumnConfig } from '../../components/paged-grid/models/grid-boolean-column.config';
import { GridColumnConfig } from '../../components/paged-grid/models/grid-column.config';
import { GridNumberColumnConfig } from '../../components/paged-grid/models/grid-number-column.config';
import { GridConfig } from '../../components/paged-grid/models/grid.config';
import { ModelTypes } from '../../core/utils/mappers/model.types';
import { ListTraderModel } from '../../models/list-trader.model';
import { TradersResource } from '../../services/resources/traders.resource';

@Component({
    selector: 'sl-traders',
    templateUrl: './traders.component.html',
    styleUrls: ['./traders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TradersComponent implements OnInit {
    gridConfig: GridConfig<ListTraderModel>;

    private readonly tradersResource = inject(TradersResource);

    ngOnInit(): void {
        this.gridConfig = new GridConfig<ListTraderModel>({
            name: 'traders',
            typeName: ModelTypes.traders,
            resource: this.tradersResource,
            pageSize: 10,
            hasNewButton: true,
            hasEditButton: true,
            hasViewButton: true,
            hasRemoveButton: true,
            canExport: true
        });
        this.gridConfig.columns = [
            new GridNumberColumnConfig({ fieldName: 'id', header: 'General.Id' }),
            new GridColumnConfig({
                fieldName: 'languageId',
                header: 'General.Language',
                isHidden: true,
                requiredPermission: 'GridColumnTraderPayment'
            }),
            new GridColumnConfig({ fieldName: 'bpId', header: 'Traders.BpId' }),
            new GridColumnConfig({ fieldName: 'displayName', header: 'Contact.DisplayName' }),
            new GridColumnConfig({ fieldName: 'name', header: 'Contact.Name', isHidden: true }),
            new GridColumnConfig({ fieldName: 'nameSupplement', header: 'Contact.NameSupplement', isHidden: true }),
            new GridColumnConfig({ fieldName: 'department', header: 'Traders.Department', isHidden: true }),
            new GridColumnConfig({ fieldName: 'street', header: 'Address.Street', isHidden: true }),
            new GridColumnConfig({ fieldName: 'streetSupplement', header: 'Address.StreetSupplement', isHidden: true }),
            new GridColumnConfig({ fieldName: 'streetNumber', header: 'Address.StreetNumber', isHidden: true }),
            new GridColumnConfig({ fieldName: 'locationZipCode', header: 'Address.ZipCode', isHidden: true }),
            new GridColumnConfig({ fieldName: 'locationCity', header: 'Address.City' }),
            new GridColumnConfig({ fieldName: 'locationCountryName', header: 'Address.Country', isHidden: true }),
            new GridBooleanColumnConfig({ fieldName: 'isPoBox', header: 'Address.IsPoBox', isHidden: true }),
            new GridColumnConfig({ fieldName: 'poBox', header: 'Address.PoBoxNr', isHidden: true }),
            new GridColumnConfig({
                fieldName: 'paymentIBAN',
                header: 'Traders.PaymentIban',
                isHidden: true,
                requiredPermission: 'GridColumnTraderPayment'
            }),
            new GridBooleanColumnConfig({ fieldName: 'hasAregData', header: 'Traders.HasAregData', isHidden: true }),
            new GridBooleanColumnConfig({
                fieldName: 'streetAfterSupplement',
                header: 'Address.StreetAfterSupplement',
                isHidden: true
            }),
            new GridColumnConfig({
                fieldName: 'paymentTypeDescription',
                header: 'Traders.PaymentType',
                isHidden: true,
                requiredPermission: 'GridColumnTraderPayment'
            }),
            new GridBooleanColumnConfig({
                fieldName: 'dividendRight',
                header: 'Shareholders.DividendRight',
                isHidden: true,
                requiredPermission: 'GridColumnTraderPayment'
            }),
            new GridNumberColumnConfig({ fieldName: 'dispoShares', header: 'Shareholders.DispoShares' }),
            new GridNumberColumnConfig({ fieldName: 'registeredShares', header: 'Shareholders.RegisteredShares' }),
            new GridNumberColumnConfig({ fieldName: 'lastSixDispo', header: 'Traders.LastSixDispo' }),
            new GridBooleanColumnConfig({ fieldName: 'hasShares', header: 'Traders.HasShares', isHidden: true })
        ];
    }
}
